import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan las variables de entorno de Supabase. Verifica tu archivo .env.local');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Función helper para obtener el usuario actual
export const getCurrentUser = async () => {
  const { data: { user } } = await supabase.auth.getUser();
  return user;
};

// Función para obtener los datos completos del usuario desde la tabla users
export const getUserProfile = async (userId) => {
  const { data, error } = await supabase
    .from('users')
    .select('*')
    .eq('id', userId)
    .single();
  
  if (error) throw error;
  return data;
};

// Función para hacer login
export const signIn = async (email, password) => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });
  
  if (error) throw error;
  return data;
};

// Función para hacer logout
export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
};

// Función para obtener URL firmada de archivos privados
export const getSignedUrl = async (bucket, path) => {
  if (!path) return null;
  
  try {
    // Extraer solo el nombre del archivo de la URL completa si es necesario
    const fileName = path.includes('/') ? path.split('/').pop() : path;
    
    const { data, error } = await supabase.storage
      .from(bucket)
      .createSignedUrl(fileName, 3600); // Válida por 1 hora

    if (error) {
      console.error('Error al obtener URL firmada:', error);
      return null;
    }

    return data.signedUrl;
  } catch (error) {
    console.error('Error al obtener URL firmada:', error);
    return null;
  }
};